export default __webpack_public_path__ + "transfix-maps/icons/P5-newWave.2c22df0a83a62315cbcce1262635dc22.png";